import Humanize from 'humanize-plus';

export const NEW_PROGRAM_TYPE = {
  CORE: 'CORE',
  ELECTIVES: 'ELECTIVES',
  TRAINING: 'TRAINING',
  OTHER: 'OTHER',
};

export const NEW_PROGRAM_TYPE_OPTIONS = Object.keys(NEW_PROGRAM_TYPE).map(
  programType => ({
    key: Humanize.capitalize(programType, true),
    text: Humanize.capitalize(programType, true),
    value: programType,
  }),
);

export const PROGRAM_STREAM_TYPE_OPTIONS = [
  { key: 'Coding', text: 'Coding', value: 'CODING' },
  { key: 'Math', text: 'Math', value: 'MATH' },
  { key: 'SAT-Demo', text: 'SAT-Demo', value: 'SAT-DEMO' },
  { key: 'SAT-English', text: 'SAT-English', value: 'SAT-ENGLISH' },
  { key: 'SAT-Math', text: 'SAT-Math', value: 'SAT-MATH' },
  { key: 'SAT-Tests', text: 'SAT-Tests', value: 'SAT-TESTS' },
  { key: 'SCIENCE', text: 'Science', value: 'SCIENCE' },
  { key: 'ELA', text: 'ELA', value: 'ELA' },
  { key: 'ELP', text: 'ELP', value: 'ELP' },
  { key: 'Other', text: 'Other', value: 'OTHER' },
];

export const SUB_STREAM_TYPE_OPTIONS = [
  { key: 'App Development', text: 'App Development', value: 'AD' },
  { key: 'Game Development', text: 'Game Development', value: 'GD' },
  { key: 'Python Coding', text: 'Python Coding', value: 'PY' },
];
